import type { Recruiter, SeatRole } from './types'

// Seat-role permission model for the console. The seat role lives on the signed-in
// recruiter (session.recruiter.seatRole) and is the source of truth the backend
// enforces too (team_members write rules; the api sidecar's requireManager). The
// UI uses these helpers to hide/disable controls a role can't use, so the screen
// matches what the server will allow.
//
//   owner      the org's account holder — full control, can't be removed/demoted
//   admin      manages the team & billing, full pipeline access
//   recruiter  full pipeline access (unlock, verify, live vouch), no team/billing
//   viewer     read-only — browse the pipeline, change nothing

/** Can manage the team — invite, change roles, revoke seats. */
export const canManageTeam = (role: SeatRole): boolean => role === 'owner' || role === 'admin'

/** Can manage billing — switch plans, update the card. */
export const canManageBilling = (role: SeatRole): boolean => role === 'owner' || role === 'admin'

/** Can act on the pipeline — spend unlocks, send verify requests, run live vouch.
 *  Everyone except a read-only viewer. */
export const canActOnPipeline = (role: SeatRole): boolean => role !== 'viewer'

/** Can reach the platform-admin area (cross-account reporting + announcements).
 *  This is VOUCHR staff, NOT a customer's org admin — it keys on `isStaff`, which
 *  is orthogonal to `seatRole`. The api sidecar re-checks it (requireStaff). */
export const canAccessAdmin = (r: Pick<Recruiter, 'isStaff'>): boolean => !!r.isStaff
